var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import config from '../const/config';
import responseCodes from '../const/responseCodes';
import { AccountIdType } from '../const/alertsConfig';
import isMockDataEnabled from '../helpers/isMockDataEnabled';
import buildCustomHeaders from '../helpers/buildCustomHeaders';
export var AlertsAPIType;
(function (AlertsAPIType) {
    AlertsAPIType[AlertsAPIType["alerts"] = 0] = "alerts";
    AlertsAPIType[AlertsAPIType["preferences"] = 1] = "preferences";
})(AlertsAPIType || (AlertsAPIType = {}));
var apiMethods = {
    GET: 'GET',
    PUT: 'PUT',
    POST: 'POST'
};
// mockData related variables
var mockDataEnabled = isMockDataEnabled();
var buildHeaders = function (token, method, correlationId) {
    var reqParams = buildCustomHeaders({ correlationId: correlationId, token: token });
    var mockDataParams = mockDataEnabled
        ? { searchParams: window.location.search.substring(1) }
        : {};
    return new Headers(__assign(__assign(__assign({}, reqParams), (method !== apiMethods.GET && {
        'Content-Type': 'application/json'
    })), mockDataParams));
};
var buildAPIHost = function (apiHost) {
    return mockDataEnabled ? config.MOCK_DATA_HOST : "".concat(apiHost, "v1");
};
var buildAccountObject = function (accountId) {
    return {
        'cipher.accountId': accountId,
        accountIdType: AccountIdType.GUID
    };
};
var buildGetParams = function (syfIdentifier) {
    return mockDataEnabled
        ? window.location.search.substring(1)
        : new URLSearchParams(buildAccountObject(syfIdentifier));
};
var makeAlertsGetRequest = function (token, syfIdentifier, tokenId, apiHost) { return __awaiter(void 0, void 0, void 0, function () {
    var response, headers, params, alertsApiHost, path, statusCode, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                headers = buildHeaders(token, 'GET', tokenId);
                params = buildGetParams(syfIdentifier);
                alertsApiHost = buildAPIHost(apiHost);
                path = 'experience/alert-preferences';
                return [4 /*yield*/, fetch("".concat(alertsApiHost, "/").concat(path, "?").concat(params), {
                        method: 'GET',
                        headers: headers
                    })];
            case 1:
                response = _a.sent();
                statusCode = response.status;
                if (statusCode === responseCodes.UNPROCESSABLE_ENTITY) {
                    throw new Error("".concat(responseCodes.UNPROCESSABLE_ENTITY));
                }
                if (statusCode >= responseCodes.BAD_REQUEST &&
                    statusCode < responseCodes.INTERNAL_SERVER_ERROR) {
                    throw new Error("".concat(responseCodes.BAD_REQUEST));
                }
                else if (statusCode >= responseCodes.INTERNAL_SERVER_ERROR &&
                    statusCode < 600) {
                    throw new Error("".concat(responseCodes.INTERNAL_SERVER_ERROR));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                if (error_1.message === "".concat(responseCodes.BAD_REQUEST) ||
                    error_1.message === "".concat(responseCodes.UNPROCESSABLE_ENTITY) ||
                    error_1.message === "".concat(responseCodes.INTERNAL_SERVER_ERROR)) {
                    throw error_1;
                }
                throw new Error("".concat(responseCodes.INTERNAL_SERVER_ERROR));
            case 4: return [2 /*return*/];
        }
    });
}); };
export var getAlertsRequest = function (token, syfIdentifier, tokenId, apiHost) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, makeAlertsGetRequest(token, syfIdentifier, tokenId, apiHost)];
    });
}); };
export var updatePreference = function (_a) {
    var token = _a.token, syfIdentifier = _a.syfIdentifier, updatedPreferences = _a.updatedPreferences, isConsentChanged = _a.isConsentChanged, tokenId = _a.tokenId, isTurnOffPreference = _a.isTurnOffPreference, apiHost = _a.apiHost;
    return __awaiter(void 0, void 0, void 0, function () {
        var prefArray, getPrefArrayForTurnOff, payloadPreferences, headers, updatePreferenceBodyParams, alertsApiHost;
        return __generator(this, function (_b) {
            prefArray = updatedPreferences.map(function (p) {
                return __assign({}, p);
            });
            getPrefArrayForTurnOff = function () {
                prefArray.forEach(function (resp) {
                    if (resp.attributes) {
                        // eslint-disable-next-line no-param-reassign
                        delete resp.attributes;
                    }
                });
                return prefArray;
            };
            payloadPreferences = isTurnOffPreference
                ? getPrefArrayForTurnOff()
                : updatedPreferences;
            headers = buildHeaders(token, 'PUT', tokenId);
            updatePreferenceBodyParams = isConsentChanged
                ? __assign(__assign({}, buildAccountObject(syfIdentifier)), { preferences: payloadPreferences, smsConsent: true }) : __assign(__assign({}, buildAccountObject(syfIdentifier)), { preferences: payloadPreferences });
            alertsApiHost = buildAPIHost(apiHost);
            return [2 /*return*/, fetch("".concat(alertsApiHost, "/alerts/preferences"), {
                    method: 'PUT',
                    headers: headers,
                    body: JSON.stringify(updatePreferenceBodyParams)
                })];
        });
    });
};
export var updateConsent = function (token, syfIdentifier, tokenId, apiHost) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, updatePreferenceBodyParams, alertsApiHost;
    return __generator(this, function (_a) {
        headers = buildHeaders(token, 'PUT', tokenId);
        updatePreferenceBodyParams = __assign(__assign({}, buildAccountObject(syfIdentifier)), { smsConsent: true });
        alertsApiHost = buildAPIHost(apiHost);
        return [2 /*return*/, fetch("".concat(alertsApiHost, "/alerts/preferences"), {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify(updatePreferenceBodyParams)
            })];
    });
}); };
